import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useCopagoCashbook = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getHistory = async () => {
    const responseData = await sendRequest({
      url: '/api/v1/copagoCashbook',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
    return responseData;
  };

  const uploadFile = async (csv, filename) => {
    const responseData = await sendRequest({
      url: '/api/v1/copagoCashbook/upload',
      method: 'POST',
      headers: authCtx.getAuthHeaders(),
      body: { csv, filename },
    });
    return responseData;
  };

  const getBatchZipURL = async (recordIds, type) => {
    const responseData = await sendRequest({
      url: '/api/v1/copagoCashbook/batch/download',
      method: 'POST',
      headers: authCtx.getAuthHeaders(),
      body: { recordIds, type },
    });
    return responseData;
  };

  const downloadFile = async (id, type) => {
    const blob = await sendRequest({
      url: `/api/v1/copagoCashbook/${id}/download/${type}`,
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
      returnBlob: true,
    });
    return blob;
  };

  return {
    isLoading,
    error,
    getHistory,
    uploadFile,
    getBatchZipURL,
    downloadFile,
  };
};

export default useCopagoCashbook;
